import styled from "styled-components";
import React from "react";
import { UIList } from "../../UI/List";
import { musics, sports } from "../../Layouts/Header";
import { Link } from "react-router-dom";

export const OtherCategory = () => {
  return (
    <div className="bs-container">
      <Styles>
        <h2>CÁC HẠNG MỤC BÌNH CHỌN KHÁC</h2>
        <h3>Âm nhạc</h3>
        <UIList items={musics} className="list-button">
          {(item) => {
            return (
              <Link to={item.href}>
                <div className="item-button">
                  <span>{item.label}</span>
                  <img src="/images/pink-arrow.png" />
                </div>
              </Link>
            );
          }}
        </UIList>
        <h3>Thể thao</h3>
        <UIList items={sports} className="list-button">
          {(item) => {
            return (
              <Link to={item.href}>
                <div className="item-button">
                  <span>{item.label}</span>
                  <img src="/images/pink-arrow.png" />
                </div>
              </Link>
            );
          }}
        </UIList>
      </Styles>
    </div>
  );
};

const Styles = styled.div`
  margin: 80px 0 20px;
  h2 {
    font-size: 32px;
    font-weight: 700;
    margin: 0 0 40px;
  }

  h3 {
    font-weight: 700;
    margin: 20px 0 8px;
  }

  .list-button {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .item-button {
    min-height: 44px;
    padding: 10px 24px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    font-weight: 700;
    background: linear-gradient(
      94.08deg,
      rgba(161, 91, 255, 0.1) 0%,
      rgba(255, 138, 90, 0.1) 100%
    );
    border-radius: 8px;
    span {
      background: -webkit-linear-gradient(right, #ff8a5a, #a15bff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    img {
      margin-left: 4px;
    }
  }
  a:focus {
    text-decoration: unset;
    outline: unset;
  }
`;
